import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { EmployeeWeekOffUploadsController } from './employee-week-off-uploads.controller';
import { EmployeeWeekOffUploadsService } from './employee-week-off-uploads.service';
import { employeeWeekOfUploadsLog } from './employee-week-off-uploads-log.entity';
import { employeeWeekOfUploads } from './employee-week-off-uploads.entity';




@Module({
  imports: [
    TypeOrmModule.forFeature([employeeWeekOfUploads,employeeWeekOfUploadsLog]),
  ],
  controllers: [EmployeeWeekOffUploadsController],
  providers: [EmployeeWeekOffUploadsService, ApplicationExceptionHandler,LogsService]
})
export class EmployeeWeekOffUploadsModule { }
